import React from 'react';
import proptypes from 'prop-types';
import { Typography } from '@one-thd/sui-atomic-components';

const { arrayOf, func, shape, string } = proptypes;

const GroupHeading = ({
  group, renderSubtitle
}) => {
  const { title, subtitle, id: groupId } = group;
  return (
    <div className="sui-flex-auto sui-my-1 sui-block">
      <Typography component="div" variant="body-lg" weight="bold" height="tight">
        {title}
      </Typography>
      {
        renderSubtitle && renderSubtitle({ groupId })
      }
      { !renderSubtitle && subtitle && (
        <Typography variant="body-base" color="subtle">
          {subtitle}
        </Typography>
      )}
    </div>
  );
};

GroupHeading.propTypes = {
  group: shape({
    id: string.isRequired,
    title: string.isRequired,
    subtitle: string
  }).isRequired,
  renderSubtitle: func
};

GroupHeading.defaultProps = {
  renderSubtitle: null
};

GroupHeading.displayName = 'GroupHeading';

export { GroupHeading };
